import React, { useEffect } from 'react'
import { useDrop } from 'react-dnd'

import { DeckCardDragType, DropItemTypes } from 'types/draggables'

type Props = {
  onDrop: (dragSource: DeckCardDragType) => void
  checkCanDrop?: (dragItems: any) => boolean
  onCanDropChange?: (canDrop: boolean) => void
  children: React.ReactNode
  className?: string
  isOverClassName?: string
}

// TODO - do we wanna replace the stack wrapper with this? We could since this should be generic enough
const DropZones = ({
  onDrop,
  checkCanDrop,
  onCanDropChange,
  children,
  className = '',
  isOverClassName = '',
}: Props) => {
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: DropItemTypes.CARD,
      drop: onDrop,
      canDrop: dragItems => (checkCanDrop ? checkCanDrop(dragItems) : true),
      collect: monitor => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [],
  )

  // Calls back to the parent when dropping becomes available or unavailable (AKA when something is being dragged)
  useEffect(() => {
    if (onCanDropChange) onCanDropChange(canDrop)
  }, [canDrop])

  return drop(<span className={`${className} ${isOver && isOverClassName}`}>{children}</span>)
}

export default DropZones
